var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "div",
        { class: _vm.wrapperClass },
        [
          _c("CompassIconButton", {
            attrs: {
              icon: "caret-left",
              size: _vm.iconButtonSize,
              disabled: !_vm.prevUrl
            },
            on: {
              click: function($event) {
                return _vm.goTo(_vm.prevUrl)
              }
            }
          }),
          _vm._v(" "),
          _c("span", { class: _vm.labelClass }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm.humanNameType(_vm.identity.type)))
            )
          ]),
          _vm._v(" "),
          _c("CompassIconButton", {
            attrs: {
              icon: "caret-right",
              size: _vm.iconButtonSize,
              disabled: !_vm.nextUrl
            },
            on: {
              click: function($event) {
                return _vm.goTo(_vm.nextUrl)
              }
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }